module.exports = __webpack_public_path__ + "static/esco-7-c102b9a92bc23b04e3e962755d79ed8d.jpeg";